import { User } from '../store/user-store';

/**
 * Funções auxiliares para controle de acesso baseado em roles
 */

export const isAdmin = (user: User | null): boolean => {
  return user?.access === 'ADMIN';
};

export const isUser = (user: User | null): boolean => {
  return user?.access === 'USER';
};

export const hasAccessToPage = (user: User | null, page: string): boolean => {
  if (!user) return false;

  // ADMIN tem acesso a tudo
  if (user.access === 'ADMIN') return true;

  // USER só tem acesso a Temas e Perguntas
  if (user.access === 'USER') {
    const allowedPages = ['/painel', '/temas', '/perguntas'];
    return allowedPages.some(allowedPath => page.startsWith(allowedPath));
  }

  return false;
};

export const getAccessiblePages = (user: User | null): string[] => {
  if (!user) return [];

  if (user.access === 'ADMIN') {
    return ['/painel', '/temas', '/perguntas', '/livrarias', '/livros', '/schools', '/exames', '/utilizadores'];
  }

  if (user.access === 'USER') {
    return ['/painel', '/temas', '/perguntas'];
  }

  return [];
};